/**
 * Pages
 *
 * @global jQuery
 * @requires plugins/jquery.owlcarousel.js
 * @requires plugins/jquery.matchheight.js
 * @requires plugins/jquery.lightgallery.js
 * @requires plugins/jquery.accordion.js
 * @author Matteo Casonato
 */


/* Home Page: Carousel */
(function ($) {
	'use strict';

    $('#js-frontend').owlCarousel({
        items               : 1,
        loop                : true,
        margin              : 0,
        nav                 : false,
        dots                : false,
        autoplay            : true,
        autoplayTimeout     : 5000,
        autoplayHoverPause  : false,
        animateOut          : 'fadeOut'
    });

}(jQuery));


/* Archive Post */
(function ($) {
	'use strict';

    document.addEventListener('load', (function(){
        var onLoad = function(){
            $('.archive-posts .entry').matchHeight();
        };
        return function(e){
            $(e.target).filter('.archive-posts .entry__src').each(onLoad);
        };
    })(), true);

}(jQuery));


/* Post */
(function ($) {
	'use strict';

    $("#js-stick").stick_in_parent({
        parent: '.l-wrapper',
        offset_top: 120
    });

}(jQuery));



/* Footer Blocks */
(function ($) {
	'use strict';

    $('.footer__block').matchHeight();

}(jQuery));


/* Services Box */
(function ($) {
	'use strict';

    $('#js-services-box .services-box__item').matchHeight();

}(jQuery));


/* Gallery */
(function ($) {
	'use strict';

    $('#js-gallery').lightGallery({
        selector: '.gallery__item a',
        download: false,
    });

}(jQuery));


/* Sidebar Menu */
(function ($) {
	'use strict';

    var submenu = $('#js-accordionmenu');

    $('<span class="accordion" />').appendTo(submenu.find('li.dropdown').children('a, span'));

    submenu.find('li.active').addClass('open');

    submenu.accordion({
		panelSelector	: 'li.dropdown',
		titleSelector	: '> a > .accordion, > span > .accordion',
		contentSelector	: '> ul',
		activeClass		: 'open'
	});

}(jQuery));


/* Header */
(function ($) {
	'use strict';

    var header          = $('.header'),
        headerFixed     = 'header--fixed',
        headerVisible   = 'header--visible',
        headerHeight    = header.height()
    ;

    $(window).on('scroll', {
        previousTop: 0
    },
    
    function () {
        var currentTop = $(window).scrollTop();

        // check if user is scrolling up
        if (currentTop < this.previousTop ) {
            // if scrolling up...
            if (currentTop > 0 && header.hasClass(headerFixed)) {
                header.addClass(headerVisible);
            } else {
                header.removeClass(headerVisible + ' ' + headerFixed);
            }
        } else if (currentTop !== this.previousTop) {
            // if scrolling down...
            header.removeClass(headerVisible);
            if(currentTop > headerHeight && !header.hasClass(headerFixed)) {
                header.addClass(headerFixed);
            }
        }
        this.previousTop = currentTop;
    });

}(jQuery));